/**
Author - Brijesh Pandey
Git - https://github.com/brijesh-pandey
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {colors} from "nxtconstants";
import {wrapper, infoline} from "../styledElements";

const propTypes = {
  handleKeyDown: PropTypes.func,
  handleOtpChange: PropTypes.func.isRequired,
  handleResend: PropTypes.func.isRequired,
  inputRefs: PropTypes.object.isRequired,
  otp: PropTypes.arrayOf(PropTypes.string).isRequired,
  userData: PropTypes.object.isRequired,
  userStep: PropTypes.number.isRequired
};

const OtpVerification = ({
  otp,
  handleOtpChange,
  userData,
  userStep,
  inputRefs,
  handleKeyDown,
  handleResend,
  isResendingOtp
}) => (
  <UserCredentialsWrapper>
    <OtpLabel>Enter OTP</OtpLabel>
    <OtpWrapper>
      <OtpInputContainer>
        {otp.map((digit, index) => (
          <OtpInput
            autoComplete="one-time-code"
            inputMode="numeric"
            key={`otp-input-${userData?.phoneNumber || ""}-${index}`}
            maxLength={1}
            pattern="[0-9]*"
            type="text"
            value={digit}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onChange={(e) => handleOtpChange(index, e.target.value)}
            ref={(el) => {
              inputRefs.current[index] = el;
            }}
          />
        ))}
      </OtpInputContainer>
    </OtpWrapper>
    <ResendOtp>
      OTP sent to {userData.phoneNumber}&nbsp;
      {isResendingOtp ? (
        <span disabled>Resending OTP...</span>
      ) : (
        <span
          disabled={isResendingOtp}
          onClick={handleResend}
        >
            Resend OTP
        </span>
      )}
    </ResendOtp>
  </UserCredentialsWrapper>
);

const UserCredentialsWrapper = styled.div`
  padding: 0;
  margin: 0;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const OtpLabel = styled.div`
  color: ${colors.textGray};
  font-size: 1.6rem;
  margin-bottom: 1.2rem;
  margin-left: 2px;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const OtpWrapper = styled.div`
  position: relative;
  margin: 0 auto 1.6rem auto;
  width: 100%;
  max-width: 400px;
`;

const OtpInputContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
`;

const OtpInput = styled.input`
  width: 100%;
  height: 5rem;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  text-align: center;
  font-size: 1.8rem;
  font-weight: 400;
  color: ${colors.black};
  background: #fff;
  transition: all 0.2s ease;
  flex: 1;
  max-width: 64px;
  box-sizing: border-box;

  &:focus {
    border-color: ${colors.primary};
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
  }

  &:disabled {
    background: ${colors.lightGray};
    cursor: not-allowed;
  }
`;

const ResendOtp = styled(infoline)`
  margin-top: 1.4rem;
  text-align: center;
  font-size: 1.6rem;

  span {
    cursor: pointer;
    color: ${colors.primary};
  }
`;

OtpVerification.propTypes = propTypes;

export default OtpVerification;
